/**
 * PanelTreeService — 트리 데이터 계산/관리
 *
 * Pure JS: Vue 의존성 없음. 계산 로직만 담당.
 */
import { calculateMaxStringIdInArray as calcMaxStringIdInArray } from '../utils/panelEntityNumbering.js';

export function createPanelTreeService() {
  return {
    calculateMaxIds(solarStrings) {
      if (!solarStrings?.length) return { maxModuleId: 0, maxStringId: 0 };
      let maxM = 0, maxS = 0;
      for (const ss of solarStrings) {
        const sid = parseInt(ss.stringId) || 0;
        if (sid > maxS) maxS = sid;
        if (ss.solarModules) {
          for (const m of ss.solarModules) {
            const mid = parseInt(m.moduleId) || parseInt(m.id) || 0;
            if (mid > maxM) maxM = mid;
          }
        }
      }
      return { maxModuleId: maxM, maxStringId: maxS };
    },

    /** Array 단위 String 표시 번호 최대값 */
    calculateMaxStringIdInArray(solarStrings, arraySeq) {
      return calcMaxStringIdInArray(solarStrings, arraySeq);
    },

    extractSolarStrings(flattenedDesign) {
      const strings = [];
      if (flattenedDesign?.solarSections) {
        flattenedDesign.solarSections.forEach(s =>
          s?.solarArrays?.forEach(a =>
            a?.solarStrings?.forEach(ss => strings.push(ss))
          )
        );
      }
      return strings;
    },

    navigateKeyboardIndex(items, currentItemId, key) {
      const index = items.findIndex(item => item?.id === currentItemId);
      if (index < 0) return null;
      const delta = key === 'ArrowDown' ? 1 : key === 'ArrowUp' ? -1 : 0;
      if (!delta) return null;
      return items[index + delta] || null;
    },

    isTreeNodeSelected(itemId, lastHighlightedId) {
      if (!itemId) return false;
      return lastHighlightedId === itemId;
    },

    stripNamePrefix(name) {
      return (name || '').replace(/^(Module|String|Array)\s+/i, '');
    }
  };
}
